import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Tab, Nav } from "react-bootstrap";
import ReactHtmlParser from "react-html-parser";

import CompanyInfo from "./tabContent/companyInfo";
import PrimaryContact from "./tabContent/primaryContact";
import ContactDetails from "./tabContent/contactDetails";
import RateCard from "./tabContent/rateCard";
//import Events from './tabContent/events';
import DynamicFieldsDetails from "../commons/dynamicFieldsDetails";
import Documents from "../commons/documentTab";

import Toast from "../commons/helpers/toast";
import {
  userGroupUrlCheck,
  getUserTimeZone,
} from "../../utils/userGroupUrlCheck";
import {
  LOGIN_SUPER_ADMIN_GROUP,
  LOGIN_AFFILIATE_GROUP,
  LOGIN_CLIENT_GROUP,
  ROUTE_REFRESH,
  ROUTE_AFFILIATE_REFRESH,
  ROUTE_AFFILIATE_CLIENTS,
  ROUTE_CLIENTS,
  TAB1,
  TAB2,
  TAB3,
  TAB4,
  TAB6,
  DYNAMIC_PAGE_ICONS,
  DEFAULT_TIME_ZONE,
} from "../../configs/staticConfigs"; // TAB7
import {
  MSG_MAIL_RESEND,
  MSG_LOGO_FORMAT,
  MSG_REQUIRED,
  MSG_CLIENT_INFO_SAVE,
  MSG_CLIENT_INFO_UPDATE,
  MSG_CLIENT_CNCT_SAVE,
  MSG_CLIENT_CNCT_SAVE_NO_EMAIL,
  MSG_CLIENT_CNCT_UPDATE,
  MSG_FILE_FORMAT_ERROR,
  MSG_FILE_SIZE_ERROR,
  MSG_ERROR,
  MSG_DYNAMIC_FIELD_DATA_SAVE_SUCCESS,
  MSG_DYNAMIC_FIELD_DATA_SAVE_ERROR,
  MSG_TIMEZONE_DATA_ERROR,
  MSG_DATA_SAVE_ERROR,
  MSG_SERVER_DATA_FETCH_ERROR,
} from "../../configs/msgConfigs";
import {
  LBL_APP_NAME,
  LBL_SETTINGS,
  LBL_COMPANY_PROFILE,
  LBL_RATE_CARD,
  LBL_ADD_CLIENT,
  LBL_EDIT_CLIENT,
} from "../../configs/labelConfigs";
import {
  validationMsgClientAdd,
  validationMsgClientDetails,
} from "../../configs/validationConfigs";

//import {sectorAllListAction} from '../../actions/settings/superadmin/sectorActions';
//import {subSectorAllListAction} from '../../actions/settings/superadmin/subSectorActions';
import {
  clientCategoryList,
  clientEditAction,
  clientCompanyInfoAddAction,
  clientPrmryCntAddAction,
  clientCompanyInfoUpdateAction,
  clientPrmryCntUpdateAction,
  clientActiveDeactiveAction,
  clientContactListAction,
  clientProfileDeactiveTabAction,
  clientListSetSliderClientId,
} from "../../actions/clientActions";
import {
  validateClientAddAction,
  validateClientDetailsAction,
} from "../../actions/validateActions";

import {
  clearAction,
  masterLocationListAction,
  primaryUsersListAction,
  resendEmailAction,
  timeZonesListAction,
  fromExpiryCertificates,
} from "../../actions/commonActions";
import {
  dynamicFieldsListAction,
  dynamicFieldsDataSaveAction,
} from "../../actions/settings/dynamicFieldsActions";
import * as types from "../../actions";

import {
  formValid,
  validateEmail,
  imageExtension,
  fileSize,
} from "../../utils/validation";

import { setStorage } from "../../utils/browserStorage";

import * as gLoc from "../../configs/googleConfigs";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import getCroppedImg from "../commons/image-cropper/cropImage";
import Cropper from "react-easy-crop";
import "react-easy-crop/react-easy-crop.css";
import ModalWindow from "../commons/helpers/modalWindow";

class ClientProfileComponent extends Component {
  constructor(props) {
    super(props);

    let clientId = "";

    let userGroupData = userGroupUrlCheck(this.props.location);
    let timeZone = getUserTimeZone(this.props.location);
    let userGroup = "";
    let grpProfileId = "";
    let isSuperAdmin = false;
    if (userGroupData !== undefined) {
      userGroup = userGroupData.user_group;
      grpProfileId = userGroupData.profile_id;
    }

    if (userGroup === LOGIN_SUPER_ADMIN_GROUP) {
      isSuperAdmin = true;
    }

    if (userGroup === LOGIN_CLIENT_GROUP) {
      clientId = grpProfileId;
    } else {
      clientId = this.props.match.params.id;
    }

    this.state = {
      formErrors: {
        companyName: "",
        companyEmail: "",
        companyContactNum: "",
        location: "",
        streetOne: "",
        streetTwo: "",
        city: "",
        state: "",
        country: "",
        postcode: "",
        locationBilling: "",
        streetOneBilling: "",
        streetTwoBilling: "",
        cityBilling: "",
        stateBilling: "",
        countryBilling: "",
        postcodeBilling: "",
        firstName: "",
        lastName: "",
        contactNumber: "",
        emailAddress: "",
        timeZone: "",
        departments: "",
      },
      clientData: {
        companyInfo: {
          companyName: null,
          companyEmail: "",
          companyContactNum: "",
          websiteUrl: "",
          companyRegNum: "",
          vatNum: "",
          locationId: null,
          location: "",
          googleLocation: null,
          venue: "",
          streetOne: "",
          streetTwo: "",
          city: null,
          state: null,
          country: null,
          postcode: null,
          additionalText: "",
          logo: "",
          signature: "",
          noLocationFound: false,
          timeZone: timeZone.id,
          category: "",

          samePhysicalAddress: false,

          noLocationFoundBilling: false,
          locationIdBilling: null,
          locationBilling: "",
          googleLocationBilling: null,
          venueBilling: "",
          streetOneBilling: "",
          streetTwoBilling: "",
          cityBilling: null,
          stateBilling: null,
          countryBilling: null,
          postcodeBilling: null,
        },
        primaryContact: {
          firstName: null,
          lastName: null,
          contactNumber: null,
          emailAddress: null,
          position: "",
          emailVerify: true,
          prmyCnctAssUserId: "",
          prmyCnctUserId: "",
          chkSendVerifyEmail: false,
          mutePushs: false,
          muteMails: false,
        },
        activeTab: TAB1,
      },
      clientId: clientId,
      imgUrl: null,
      toastMessage: "",
      toastFlag: false,
      toastSuccess: true,
      formClick: false,
      isPrmCnctList: false,
      totalEvent: "",
      totalShift: "",
      isPrimaryContactSuccess: false,
      logoLabel: "", // MSG_LOGO_FORMAT
      signatureLabel: "", // MSG_LOGO_FORMAT
      isLogoValid: true,
      isSignatureValid: true,
      userType: LOGIN_CLIENT_GROUP,
      listDynData: { groupId: 0, reqFrom: 0 },
      dynFieldsAllItems: [],
      dynFieldsActiveItem: {
        id: 0,
        name: "",
        field_details: [],
        user_type: 0,
        show_tab: true,
        icon_name: "",
      },
      activePageId: 0,
      dynamicFieldsSavedData: [],
      locGoogleCodes: {
        streetOne: "",
        streetTwo: "",
        city: "",
        state: "",
        country: "",
        postcode: "",
      },
      timeZonesList: [],
      defaultTimeZoneId: timeZone.id,
      is_active: "",
      client_affiliate_status: "",
      clientProfileTabActiveShown: "",
      validationMsgArr: [],
      primaryContactEmailAddress: "",
      userGroup: userGroup,
      logoImgUrl: "",
      signImgUrl: "",
      image: "",
      crop: { x: 0, y: 0 },
      zoom: 1,
      aspect: 4 / 4,
      croppedArea: {},
      croppedAreaPixels: {},
      rotation: 0,
      imgObj: null,
      isSuperAdmin: isSuperAdmin,
    };

    this.onHandleChange = this.onHandleChange.bind(this);
    this.saveFormData = this.saveFormData.bind(this);
    this.onTabChange = this.onTabChange.bind(this);
    this.setToasterState = this.setToasterState.bind(this);
    this.changePage = this.changePage.bind(this);

    this.logoModalCropper = React.createRef();
    this.signModalCropper = React.createRef();
  }

  callValidate = () => {
    if (this.state.clientId)
      this.props.validateClientDetailsAction(this.state.clientId);
  };

  changePage = (event, refPageId) => {
    if (this.state.activePageId !== refPageId) {
      let allPagesFieldsObj = [];
      let newActiveObj = {};
      this.state.dynFieldsAllItems.forEach((item, index) => {
        if (item.id === this.state.activePageId)
          allPagesFieldsObj.push(this.state.dynFieldsActiveItem);
        else allPagesFieldsObj.push(item);
        if (item.id === refPageId) {
          newActiveObj = item;
        }
      });
      this.setState({
        activePageId: refPageId,
        dynFieldsActiveItem: newActiveObj,
        dynFieldsAllItems: allPagesFieldsObj,
        toastFlag: false,
        toastMessage: "",
        toastSuccess: true,
      });
    }
  };

  onHandleChange = (e, tab) => {
    const { name } = e.target;
    let value =
      e.target.type === "file"
        ? e.target.files[0]
        : e.target.type === "checkbox"
        ? e.target.checked
        : e.target.value;

    let trimmedValue = "";
    if (
      e.target.type === "text" ||
      e.target.type === "tel" ||
      e.target.type === "email"
    ) {
      trimmedValue = value.trim();
    }

    let formErrors = this.state.formErrors;
    let logoValid = true;
    let logoError = ""; //MSG_LOGO_FORMAT;
    let signatureValid = true;
    let signatureError = ""; //MSG_LOGO_FORMAT;

    switch (name) {
      case "chkSendVerifyEmail":
        value = e.target.checked;
        break;
      case "logo":
        if (!fileSize(value.size)) {
          logoError = MSG_FILE_SIZE_ERROR;
          logoValid = false;
        }
        if (!imageExtension(value.name)) {
          logoError = MSG_LOGO_FORMAT; // MSG_FILE_FORMAT_ERROR;
          logoValid = false;
        }
        break;
      case "signature":
        if (!fileSize(value.size)) {
          signatureError = MSG_FILE_SIZE_ERROR;
          signatureValid = false;
        }
        if (!imageExtension(value.name)) {
          signatureError = MSG_LOGO_FORMAT; // MSG_FILE_FORMAT_ERROR;
          signatureValid = false;
        }
        break;
      case "companyName":
        formErrors.companyName = trimmedValue.length <= 0 ? MSG_REQUIRED : "";
        break;
      case "companyEmail":
        formErrors.companyEmail =
          trimmedValue.length > 0 && validateEmail(trimmedValue) === false
            ? MSG_REQUIRED
            : "";
        break;
      // case 'sector':
      //     formErrors.sector =
      //     value.length <=0 || Number(value)===0 ?
      //     MSG_REQUIRED : "";
      //     break;
      // case 'subSector':
      //     formErrors.subSector =
      //     value.length <=0 || Number(value)===0 ?
      //     MSG_REQUIRED : ""
      //     break;
      case "firstName":
        formErrors.firstName = trimmedValue.length <= 0 ? MSG_REQUIRED : "";
        break;
      case "lastName":
        formErrors.lastName = trimmedValue.length <= 0 ? MSG_REQUIRED : "";
        break;
      case "contactNumber":
        formErrors.contactNumber = trimmedValue.length <= 0 ? MSG_REQUIRED : "";
        break;
      case "emailAddress":
        formErrors.emailAddress =
          trimmedValue.length <= 0 || validateEmail(trimmedValue) === false
            ? MSG_REQUIRED
            : "";
        break;
      // case 'streetOne':
      //     formErrors.streetOne =
      //     value.length <=0  ?
      //      MSG_REQUIRED : "";
      //     break;
      // case 'streetTwo':
      //     formErrors.streetTwo =
      //     trimmedValue.length <=0  ?
      //     MSG_REQUIRED : "";
      //     break;
      case "city":
        formErrors.city = trimmedValue.length <= 0 ? MSG_REQUIRED : "";
        break;
      case "state":
        formErrors.state = trimmedValue.length <= 0 ? MSG_REQUIRED : "";
        break;
      case "country":
        formErrors.country = trimmedValue.length <= 0 ? MSG_REQUIRED : "";
        break;
      case "postcode":
        formErrors.postcode = trimmedValue.length <= 0 ? MSG_REQUIRED : "";
        break;
      case "cityBilling":
        formErrors.cityBilling = trimmedValue.length <= 0 ? MSG_REQUIRED : "";
        break;
      case "stateBilling":
        formErrors.stateBilling = trimmedValue.length <= 0 ? MSG_REQUIRED : "";
        break;
      case "countryBilling":
        formErrors.countryBilling = trimmedValue.length <= 0 ? MSG_REQUIRED : "";
        break;
      case "postcodeBilling":
        formErrors.postcodeBilling = trimmedValue.length <= 0 ? MSG_REQUIRED : "";
        break;
      case "timeZone":
        formErrors.timeZone =
          value.length <= 0 || Number(value) === 0 ? MSG_REQUIRED : "";
        break;

      default:
        break;
    }

    let clientData = this.state.clientData;
    let companyInfo = this.state.clientData.companyInfo;
    let primaryContact = this.state.clientData.primaryContact;

    if (tab === TAB1) {
      if (name === "logo" && logoError === "") {
        companyInfo[name] = value;
      }
      if (name === "signature" && signatureError === "") {
        companyInfo[name] = value;
      } else if (name !== "logo" || name !== "signature") {
        companyInfo[name] = value;
      }
    } else if (tab === TAB2) {
      primaryContact[name] = value;
    }

    if (e.target.type === "file" && name == "logo") {
      let imgUrl = "";
      let imgObj = null;
      if (imageExtension(e.target.files[0].name) && logoError === "") {
        imgUrl = URL.createObjectURL(e.target.files[0]);
        imgObj = e.target.files[0];
        this.setState(
          { imgUrl: imgUrl, imgObj: imgObj, logoImgUrl: imgUrl },
          () => {
            document.getElementById("uploadLogo").value = "";
            this.openLogoCropModal();
          }
        );
      }
    } else if (e.target.type === "file" && name == "signature") {
      let signatureUrl = "";
      let imgObj = null;
      if (imageExtension(e.target.files[0].name) && signatureError === "") {
        signatureUrl = URL.createObjectURL(e.target.files[0]);
        imgObj = e.target.files[0];
        this.setState({
          signatureUrl: signatureUrl,
          imgObj: imgObj,
          signImgUrl: signatureUrl,
        });
        document.getElementById("uploadSignature").value = "";
        this.openSignCropModal();
      }
    }
    this.setState({
      formErrors,
      clientData,
      isLogoValid: logoValid,
      logoLabel: logoError,
      isSignatureValid: signatureValid,
      signatureLabel: signatureError,
    });
  };

  onCropChange = (crop) => {
    this.setState({ crop });
  };

  onCropComplete = (croppedArea, croppedAreaPixels) => {
    this.setState({
      croppedArea: croppedArea,
      croppedAreaPixels: croppedAreaPixels,
    });
  };

  onZoomChange = (zoom) => {
    this.setState({ zoom });
  };

  openLogoCropModal = () => {
    this.logoModalCropper.current.handleOpenModal();
  };

  openSignCropModal = () => {
    this.signModalCropper.current.handleOpenModal();
  };
  cropImage(e, cropModule) {
    let { imgObj, croppedAreaPixels, rotation, imgUrl } = this.state;
    const obj = this;
    let canvas = getCroppedImg(
      imgObj,
      croppedAreaPixels,
      obj,
      rotation,
      cropModule
    );
  }

  onSearchLocation = (query) => {
    if (query.length === 3) {
      this.props.masterLocationListAction(query);
    }
  };

  onTabChange = (e, tab) => {
    let clientData = this.state.clientData;
    clientData["activeTab"] = tab;
    if (tab === TAB3) {
      this.props.clientContactListAction({
        clientId: this.state.clientId,
        column: "-id",
      });
    }
    this.setState({ clientData });
  };

  onPhoneInputChange = (value, data, event, formattedValue) => {
    let clientData = this.state.clientData;
    let companyInfo = this.state.clientData.companyInfo;
    companyInfo["companyContactNum"] = formattedValue.trim();
    this.setState({ clientData });
  };

  onContactInputChange = (value, data, event, formattedValue) => {
    let clientData = this.state.clientData;
    let formErrors = this.state.formErrors;
    let primaryContact = this.state.clientData.primaryContact;
    primaryContact["contactNumber"] = formattedValue.trim();
    formErrors.contactNumber =
      value.trim() === data.dialCode ? MSG_REQUIRED : "";
    formErrors.contactNumber =
      formattedValue.trim().length < 5 ? MSG_REQUIRED : "";
    this.setState({ formErrors, clientData });
  };

  onSelectLocation = (selected, id) => {
    if (selected.length > 0) {
      const selectedLoc = selected[0];
      const { clientData } = this.state;
      const { companyInfo } = clientData;
  
      // Determine if it's billing or regular
      const isBilling = id !== "locationSearch";
      const prefix = isBilling ? "Billing" : "";
  
      const fields = {
        [`locationId${prefix}`]: selectedLoc.id || "",
        [`location${prefix}`]: selectedLoc.location || "",
        [`googleLocation${prefix}`]: selectedLoc.lat_long || "",
        [`venue${prefix}`]: selectedLoc.venue || "",
        [`streetOne${prefix}`]: selectedLoc.street1 || "",
        [`streetTwo${prefix}`]: selectedLoc.street2 || "",
        [`city${prefix}`]: selectedLoc.city || "",
        [`state${prefix}`]: selectedLoc.state || "",
        [`country${prefix}`]: selectedLoc.country || "",
        [`postcode${prefix}`]: selectedLoc.postcode || "",
        noLocationFound: false,
      };
  
      // Update companyInfo with the fields
      Object.assign(companyInfo, fields);
  
      this.setState({ clientData });
      this.resetFormErrors();
    }
  };
  

  onSelectPrmyUser = (e) => {
    let clientData = this.state.clientData;
    let primaryContact = this.state.clientData.primaryContact;
    primaryContact["prmyCnctAssUserId"] = e.target.value;
    const filteredUsers = this.props.prmryUsers.filter(
      (item) => item.associate_id === Number(e.target.value)
    );
    primaryContact["firstName"] = filteredUsers[0].first_name;
    primaryContact["lastName"] = filteredUsers[0].last_name;
    primaryContact["contactNumber"] = filteredUsers[0].phone_number;
    primaryContact["emailAddress"] = filteredUsers[0].email;
    primaryContact["position"] =
      filteredUsers[0].position === null ? "" : filteredUsers[0].position;
    primaryContact["muteMails"] = filteredUsers[0].mute_mails;
    primaryContact["mutePushs"] = filteredUsers[0].mute_pushs;
    this.setState({ clientData });
  };

  resetFormErrors = () => {
    let formErrors = this.state.formErrors;
    formErrors.streetOne = "";
    formErrors.streetTwo = "";
    formErrors.city = "";
    formErrors.state = "";
    formErrors.country = "";
    formErrors.postcode = "";
    formErrors.streetOneBilling = "";
    formErrors.streetTwoBilling = "";
    formErrors.cityBilling = "";
    formErrors.stateBilling = "";
    formErrors.countryBilling = "";
    formErrors.postcodeBilling = "";
    formErrors.firstName = "";
    formErrors.lastName = "";
    formErrors.contactNumber = "";
    formErrors.emailAddress = "";
    formErrors.timeZone = "";
    this.setState({ formErrors });
  };

  onCloseToast = () => {
    this.setState({ toastFlag: false, toastMessage: "", toastSuccess: false });
  };

  setToasterState(isEnabled, message, isSucces, isAutoHide = true) {
    this.setState({
      toastFlag: isEnabled,
      toastMessage: message,
      toastSuccess: isSucces,
    });
    if (isAutoHide) {
      setTimeout(() => {
        this.onCloseToast();
      }, 3000);
    } // else{
    //     setTimeout(()=> {
    //         this.onCloseToast();
    //     }, 10000000000000);
    // }
  }

  resendEmail = (userId) => {
    this.props.resendEmailAction(userId);
  };

  saveFormData = (e, tab) => {
    e.preventDefault();
    // WHILE ADDING A CLIENT CLEAR THE MASTER DATA ERROR ELEMENT FROM validationMsgArr
    if (!this.state.clientId)
      this.setState({ validationMsgArr: [], formClick: true });
    else this.setState({ formClick: true });

    this.setState({ formClick: true });

    const clientId = this.state.clientId;
    const data = new FormData();
    const formErrors = this.state.formErrors;

    if (tab === TAB1) {
      const { companyInfo } = this.state.clientData;
      if (formValid(this.state)) {
        data.append("company_name", companyInfo.companyName);
        data.append("web_site", companyInfo.websiteUrl);
        data.append("phone_number", companyInfo.companyContactNum);
        data.append("company_email", companyInfo.companyEmail);
        data.append("company_no", companyInfo.companyRegNum);
        data.append("vat_number", companyInfo.vatNum);
        data.append("sector", companyInfo.sector ? companyInfo.sector : 0);
        data.append(
          "sub_sector",
          companyInfo.subSector ? companyInfo.subSector : 0
        );
        data.append("note", companyInfo.additionalText);
        data.append("logo", companyInfo.logo);
        data.append("signature", companyInfo.signature);
        data.append("time_zone", companyInfo.timeZone);

        if (companyInfo.locationId) {
          data.append("location_id", companyInfo.locationId);
        } 
          let location_data = {
            venue: companyInfo.venue,
            street1: companyInfo.streetOne,
            street2: companyInfo.streetTwo,
            city: companyInfo.city,
            state: companyInfo.state,
            country: companyInfo.country,
            postcode: companyInfo.postcode,
            lat_long: companyInfo.lat_long,
          };
          data.append("location_data", JSON.stringify(location_data));
      

        if (companyInfo.samePhysicalAddress) {
          data.append('billing_as_physical', companyInfo.samePhysicalAddress);
      } else {
           if (companyInfo.locationIdBilling) {
          data.append('location_billing_id', companyInfo.locationIdBilling);
           }
          let locationBilling_data = { venue: companyInfo.venueBilling, street1: companyInfo.streetOneBilling, street2: companyInfo.streetTwoBilling, city: companyInfo.cityBilling, state: companyInfo.stateBilling, country: companyInfo.countryBilling, postcode: companyInfo.postcodeBilling, lat_long: companyInfo.googleLocationBilling };
          data.append('location_billing_data', JSON.stringify(locationBilling_data));
          }
        if (clientId === undefined) {
          this.props.clientCompanyInfoAddAction(data);
        } else {
          data.append("id", clientId);
          this.props.clientCompanyInfoUpdateAction(data);
        }
      } else {
        if (companyInfo.companyName === null) {
          formErrors.companyName = MSG_REQUIRED;
        }
        // if(companyInfo.sector===0){
        //     formErrors.sector = MSG_REQUIRED;
        // }
        // if(companyInfo.subSector===0){
        //     formErrors.subSector = MSG_REQUIRED;
        // }
        // if(companyInfo.streetOne===null){
        //     formErrors.streetOne = MSG_REQUIRED;
        // }
        // if(companyInfo.streetTwo===null){
        //     formErrors.streetTwo = MSG_REQUIRED;
        // }
        if (companyInfo.city === null) {
          formErrors.city = MSG_REQUIRED;
        }
        if (companyInfo.state === null) {
          formErrors.state = MSG_REQUIRED;
        }
        if (companyInfo.country === null) {
          formErrors.country = MSG_REQUIRED;
        }
        if (companyInfo.postcode === null) {
          formErrors.postcode = MSG_REQUIRED;
        }
        if (companyInfo.cityBilling === null) {
          formErrors.cityBilling = MSG_REQUIRED;
        }
        if (companyInfo.stateBilling === null) {
          formErrors.stateBilling = MSG_REQUIRED;
        }
        if (companyInfo.countryBilling === null) {
          formErrors.countryBilling = MSG_REQUIRED;
        }
        if (companyInfo.postcodeBilling === null) {
          formErrors.postcodeBilling = MSG_REQUIRED;
        }
        if (companyInfo.timeZone === null) {
          formErrors.timeZone = MSG_REQUIRED;
        }

        this.setState({ formErrors });
      }
    } else if (tab === TAB2) {
      const { primaryContact } = this.state.clientData;
      if (formValid(this.state)) {
        if (this.state.isPrmCnctList) {
          let primaryContactData = {
            profileId: clientId,
            userType: LOGIN_CLIENT_GROUP,
            associate_id: primaryContact.prmyCnctAssUserId,
            mute_pushs: primaryContact.mutePushs,
            mute_mails: primaryContact.muteMails,
          };
          this.props.clientPrmryCntUpdateAction(primaryContactData);
        } else {
          let pcData = {
            client_profile_id: clientId,
            first_name: primaryContact.firstName,
            last_name: primaryContact.lastName,
            contact_number: primaryContact.contactNumber,
            email: primaryContact.emailAddress,
            send_email_verification: primaryContact.chkSendVerifyEmail,
            position: primaryContact.position,
            mute_pushs: primaryContact.mutePushs,
            mute_mails: primaryContact.muteMails,
          };
          this.props.clientPrmryCntAddAction(pcData);
        }
      } else {
        if (primaryContact.firstName === null) {
          formErrors.firstName = MSG_REQUIRED;
        }
        if (primaryContact.lastName === null) {
          formErrors.lastName = MSG_REQUIRED;
        }
        if (primaryContact.contactNumber === null) {
          formErrors.contactNumber = MSG_REQUIRED;
        }
        if (primaryContact.emailAddress === null) {
          formErrors.emailAddress = MSG_REQUIRED;
        }

        this.setState({ formErrors });
      }
    }
  };

  deactivateUser = () => {
    if (this.state.clientId) {
      let data = {
        active: false,
        profileId: this.state.clientId,
      };
      this.props.clientActiveDeactiveAction(data);
    }
  };

  activateUser = () => {
    if (this.state.clientId) {
      let data = {
        active: true,
        profileId: this.state.clientId,
      };
      this.props.clientActiveDeactiveAction(data);
    }
  };

  setStateUpdate(client, activity, status, errorData) {
    let formErrors = this.state.formErrors;
    if (activity === types.CLIENT_CMPNY_INFO_ADD_SUCCESS) {
      // this.props.validateClientDetailsAction(this.state.clientId);
      this.setToasterState(true, MSG_CLIENT_INFO_SAVE, true);
      this.setState({ clientId: client.id }, () => {
        this.props.clientEditAction(client.id);
      });
      // newClientId
    } else if (activity === types.CLIENT_CMPNY_INFO_ADD_ERROR) {
      if (status === 400) {
        if (errorData.hasOwnProperty("company_name")) {
          formErrors.companyName = errorData.company_name[0];
        } else {
          this.setToasterState(true, MSG_DATA_SAVE_ERROR, false); // JSON.stringify(errorData)
        }
        this.setState(formErrors);
      } else {
        this.setToasterState(true, MSG_DATA_SAVE_ERROR, false);
        // if(errorData.hasOwnProperty('message')){
        //     this.setToasterState(true,errorData.message,false);
        // }else{
        //     this.setToasterState(true,MSG_DATA_SAVE_ERROR,false);
        // }
      }
    } else if (activity === types.CLIENT_CMPNY_INFO_UPDATE_SUCCESS) {
      this.callValidate();
      let userGroupData = userGroupUrlCheck(this.props.location);
      if (
        userGroupData !== undefined &&
        userGroupData.user_group &&
        userGroupData.user_group === LOGIN_CLIENT_GROUP
      ) {
        let timeZoneId = this.state.clientData.companyInfo.timeZone;
        let tz = this.state.timeZonesList;
        let newTZ = tz.filter((item) => Number(item.id) === Number(timeZoneId));
        userGroupData.time_zone = newTZ[0];
        // SET NEW LOGO TO STORE
        let clientUpdatedData = this.props.clientUpdatedData;
        if (clientUpdatedData.logo && clientUpdatedData.logo.length > 1) {
          userGroupData.company_image = clientUpdatedData.logo;
        }
        setStorage("client", JSON.stringify(userGroupData));
      }
      this.setToasterState(true, MSG_CLIENT_INFO_UPDATE, true);
    } else if (activity === types.CLIENT_CMPNY_INFO_UPDATE_ERROR) {
      if (status === 400) {
        if (errorData.hasOwnProperty("company_name")) {
          formErrors.companyName = errorData.company_name[0];
        } else {
          this.setToasterState(true, MSG_DATA_SAVE_ERROR, false); // JSON.stringify(errorData)
        }
        this.setState(formErrors);
      } else {
        this.setToasterState(true, MSG_DATA_SAVE_ERROR, false);
        // if(errorData.hasOwnProperty('message')){
        //     this.setToasterState(true,errorData.message,false);
        // }else{
        //     this.setToasterState(true,JSON.stringify(errorData),false);
        // }
      }
    } else if (activity === types.CLIENT_PRMRY_CNCT_ADD_SUCCESS) {
      let emailAddress = this.state.clientData.primaryContact.emailAddress;
      this.setState({
        isPrimaryContactSuccess: true,
        primaryContactEmailAddress: emailAddress,
      });
      if (this.state.clientData.primaryContact.chkSendVerifyEmail)
        this.setToasterState(true, MSG_CLIENT_CNCT_SAVE, true, false);
      else
        this.setToasterState(true, MSG_CLIENT_CNCT_SAVE_NO_EMAIL, true, false);
      let data = {
        profileId: client.id,
        userType: LOGIN_CLIENT_GROUP,
      };
      this.props.primaryUsersListAction(data);
      this.callValidate();
    } else if (activity === types.CLIENT_PRMRY_CNCT_ADD_ERROR) {
      if (status === 400) {
        if (errorData.hasOwnProperty("email")) {
          formErrors.emailAddress = errorData.email[0];
        } else {
          this.setToasterState(true, MSG_DATA_SAVE_ERROR, false); // JSON.stringify(errorData)
        }
        this.setState(formErrors);
      } else {
        this.setToasterState(true, MSG_DATA_SAVE_ERROR, false);
        // if(errorData.hasOwnProperty('message')){
        //     this.setToasterState(true,errorData.message,false);
        // }else{
        //     this.setToasterState(true,JSON.stringify(errorData),false);
        // }
      }
    } else if (activity === types.CLIENT_PRMRY_CNCT_UPDATE_SUCCESS) {
      this.setToasterState(true, MSG_CLIENT_CNCT_UPDATE, true);
      let data = {
        profileId: client.id,
        userType: LOGIN_CLIENT_GROUP,
      };
      this.props.primaryUsersListAction(data);
      this.callValidate();
    } else if (activity === types.CLIENT_PRMRY_CNCT_UPDATE_ERROR) {
      if (status === 400) {
        if (errorData.hasOwnProperty("email")) {
          formErrors.emailAddress = errorData.email[0];
        } else {
          this.setToasterState(true, MSG_DATA_SAVE_ERROR, false); // JSON.stringify(errorData)
        }
        this.setState(formErrors);
      } else {
        this.setToasterState(true, MSG_DATA_SAVE_ERROR, false); // JSON.stringify(errorData)
        // if(errorData.hasOwnProperty('message')){
        //     this.setToasterState(true,errorData.message,false);
        // }else{
        //     this.setToasterState(true,JSON.stringify(errorData),false);
        // }
      }
    } else if (activity === types.CLIENT_EDIT_SUCCESS) {
      // sector:client.sector, subSector:client.subSector,
      this.setState({
        clientData: {
          companyInfo: {
            companyName: client.companyName ? client.companyName : "",
            companyEmail: client.companyEmail ? client.companyEmail : "",
            companyContactNum: client.companyContactNum
              ? client.companyContactNum
              : "",
            websiteUrl: client.websiteUrl ? client.websiteUrl : "",
            companyRegNum: client.companyRegNum ? client.companyRegNum : "",
            vatNum: client.vatNum ? client.vatNum : "",
            location: client.location ? client.location : "",
            locationId: client.locationId,
            googleLocation: client.googleLocation ? client.googleLocation : "",
            venue: client.venue ? client.venue : "",
            streetOne: client.streetOne ? client.streetOne : "",
            streetTwo: client.streetTwo ? client.streetTwo : "",
            city: client.city ? client.city : "",
            state: client.state ? client.state : "",
            country: client.country ? client.country : "",
            postcode: client.postcode ? client.postcode : "",
            additionalText: client.additionalText ? client.additionalText : "",

            samePhysicalAddress: client.locationId === client.locationIdBilling,
                        
                        ...(client.locationId !== client.locationIdBilling && {
                            locationBilling: client.locationBilling || '',
                            locationIdBilling: client.locationIdBilling,
                            googleLocationBilling: client.googleLocationBilling || '',
                            venueBilling: client.venueBilling || '',
                            streetOneBilling: client.streetOneBilling || '',
                            streetTwoBilling: client.streetTwoBilling || '',
                            cityBilling: client.cityBilling || '',
                            stateBilling: client.stateBilling || '',
                            countryBilling: client.countryBilling || '',
                            postcodeBilling: client.postcodeBilling || '',
                        }),
                        
            logo: "",
            signature: "",
            noLocationFound: false,
            timeZone: client.timeZone ? client.timeZone.id : null,
          },
          primaryContact: {
            prmyCnctAssUserId: client.prmyCnctAssUserId,
            prmyCnctUserId: client.prmyCnctUserId,
            firstName: client.firstName,
            lastName: client.lastName,
            contactNumber: client.contactNumber,
            emailAddress: client.emailAddress,
            position: client.position,
            emailVerify: client.emailVerify,
            chkSendVerifyEmail: false,
            mutePushs: client.mutePushs,
            muteMails: client.muteMails,
          },
          activeTab: TAB1,
        },
        imgUrl: client.logo,
        signatureUrl: client.signature,
        isPrmCnctList: client.isPrmCnctList,
        totalEvent: client.totalEvent,
        totalShift: client.totalShift,
        clientId: client.id,
        dynamicFieldsSavedData: client.dynamic_fields,
        is_active: client.is_active,
        client_affiliate_status: client.client_affiliate_status,
        primaryContactEmailAddress: client.emailAddress,
      });
      if (client.isPrmCnctList) {
        let data = {
          profileId: client.id,
          userType: LOGIN_CLIENT_GROUP,
        };
        this.props.primaryUsersListAction(data);
      }

      const { location } = this.props;
      let userGroupData = userGroupUrlCheck(location);
      let userGroup = "";
      if (userGroupData !== undefined) {
        userGroup = userGroupData.user_group;
      }

      let grpProfileId = userGroupData.profile_id;
      let listDynData = {
        groupId: LOGIN_CLIENT_GROUP,
        reqFrom: userGroup,
        profileId: grpProfileId,
      };
      this.setState({ listDynData: listDynData }, () => {
        this.props.dynamicFieldsListAction(listDynData);
      });

      // IF THIS PAGE IS CALLED FORM CERTIFICATES LISTING - MAKE DOCUMENTS TAB ACTIVE
      if (
        this.props.clientProfileTabActive !==
        this.state.clientProfileTabActiveShown
      ) {
        if (
          this.props.clientProfileTabActive &&
          this.props.clientProfileTabActive.length > 0 &&
          this.state.clientProfileTabActiveShown === ""
        ) {
          this.setState({
            clientProfileTabActiveShown: this.props.clientProfileTabActive,
          });
          this.onTabChange("", this.props.clientProfileTabActive);
        }
        this.props.clientProfileDeactiveTabAction("");
      }
    } else if (activity === types.CLIENT_EDIT_ERROR) {
      let gotoURL =
        this.state.userGroup === LOGIN_SUPER_ADMIN_GROUP
          ? ROUTE_CLIENTS
          : ROUTE_AFFILIATE_CLIENTS;
      if (status === 404) {
        this.props.history.push(gotoURL);
      } else {
        this.setToasterState(true, MSG_SERVER_DATA_FETCH_ERROR, false);
      }
    } else if (activity === types.CLIENT_ACTIVE_DEACTIVE_SUCCESS) {
      // LOGIN_AFFILIATE_GROUP
      let gotoURL =
        this.state.userGroup === LOGIN_SUPER_ADMIN_GROUP
          ? ROUTE_CLIENTS
          : ROUTE_AFFILIATE_CLIENTS;
      this.props.history.push({
        pathname: gotoURL,
        state: {
          clientName: this.state.clientData.companyInfo.companyName,
        },
      });
    } else if (activity === types.CLIENT_ACTIVE_DEACTIVE_ERROR) {
      this.setToasterState(true, MSG_DATA_SAVE_ERROR, false); // JSON.stringify(errorData)
    } else if (activity === types.RESEND_EMAIL_SUCCESS) {
      this.setToasterState(true, MSG_MAIL_RESEND, true, false);
    } else if (activity === types.RESEND_EMAIL_ERROR) {
      this.setToasterState(true, MSG_DATA_SAVE_ERROR, false);
    }
  }

//   googleLocSelect = (address) => {
//     let { formErrors } = this.state;
//     let clientData = this.state.clientData;
//     let locGoogleCodes = this.state.locGoogleCodes;

//     geocodeByAddress(address)
//       .then((results) => {
//         clientData.companyInfo.streetOne = "";
//         clientData.companyInfo.streetTwo = "";
//         clientData.companyInfo.city = "";
//         clientData.companyInfo.state = "";
//         clientData.companyInfo.country = "";
//         clientData.companyInfo.postcode = "";
//         clientData.companyInfo.location = results[0].formatted_address;
//         let tmpArr = [];
//         tmpArr = address.split(",");
//         clientData.companyInfo.venue = tmpArr[0];

//         locGoogleCodes.streetOne = "";
//         locGoogleCodes.streetTwo = "";
//         locGoogleCodes.city = "";
//         locGoogleCodes.state = "";
//         locGoogleCodes.country = "";
//         locGoogleCodes.postcode = "";

//         let allAddress = results[0].address_components;
//         let addrTypes = [];
//         let foundVar = 0;
//         let tmpVal = "";
//         allAddress.forEach((element) => {
//           addrTypes = element.types;
//           foundVar = 0;
//           addrTypes.forEach((item) => {
//             tmpVal = element.long_name.trim().length
//               ? element.long_name.trim()
//               : element.short_name.trim().length
//               ? element.short_name.trim()
//               : "";
//             if (foundVar === 0 && tmpVal !== "") {
//               if (gLoc.GOOGLE_LOCATION_STREET.includes(item)) {
//                 foundVar = 1;
//                 if (clientData.companyInfo["streetOne"].trim() === "")
//                   clientData.companyInfo["streetOne"] = tmpVal;
//                 else clientData.companyInfo["streetOne"] += ", " + tmpVal;

//                 if (locGoogleCodes["streetOne"].trim() === "")
//                   locGoogleCodes["streetOne"] = item;
//                 else locGoogleCodes["streetOne"] += ", " + item;
//               } else if (gLoc.GOOGLE_LOCATION_STREET2.includes(item)) {
//                 foundVar = 1;
//                 if (clientData.companyInfo["streetTwo"].trim() === "")
//                   clientData.companyInfo["streetTwo"] = tmpVal;
//                 else clientData.companyInfo["streetTwo"] += ", " + tmpVal;
//                 if (locGoogleCodes["streetTwo"].trim() === "")
//                   locGoogleCodes["streetTwo"] = item;
//                 else locGoogleCodes["streetTwo"] += ", " + item;
//               } else if (gLoc.GOOGLE_LOCATION_CITY.includes(item)) {
//                 foundVar = 1;
//                 if (clientData.companyInfo["city"].trim() === "")
//                   clientData.companyInfo["city"] = tmpVal;
//                 else clientData.companyInfo["city"] += ", " + tmpVal;
//                 if (locGoogleCodes["city"].trim() === "")
//                   locGoogleCodes["city"] = item;
//                 else locGoogleCodes["city"] += ", " + item;
//               } else if (gLoc.GOOGLE_LOCATION_STATE.includes(item)) {
//                 foundVar = 1;
//                 if (clientData.companyInfo["state"].trim() === "")
//                   clientData.companyInfo["state"] = tmpVal;
//                 else clientData.companyInfo["state"] += ", " + tmpVal;
//                 if (locGoogleCodes["state"].trim() === "")
//                   locGoogleCodes["state"] = item;
//                 else locGoogleCodes["state"] += ", " + item;
//               } else if (gLoc.GOOGLE_LOCATION_COUNTRY.includes(item)) {
//                 foundVar = 1;
//                 if (clientData.companyInfo["country"].trim() === "")
//                   clientData.companyInfo["country"] = tmpVal;
//                 else clientData.companyInfo["country"] += ", " + tmpVal;
//                 if (locGoogleCodes["country"].trim() === "")
//                   locGoogleCodes["country"] = item;
//                 else locGoogleCodes["country"] += ", " + item;
//               } else if (gLoc.GOOGLE_LOCATION_POSTCODE.includes(item)) {
//                 foundVar = 1;
//                 if (clientData.companyInfo["postcode"].trim() === "")
//                   clientData.companyInfo["postcode"] = tmpVal;
//                 else clientData.companyInfo["postcode"] += ", " + tmpVal;
//                 if (locGoogleCodes["postcode"].trim() === "")
//                   locGoogleCodes["postcode"] = item;
//                 else locGoogleCodes["postcode"] += ", " + item;
//               }
//             }
//           });
//         });

//         getLatLng(results[0]).then((latLng) => {
//           clientData.companyInfo["googleLocation"] =
//             latLng.lat + "," + latLng.lng;
//         });
//       })
//       .then(() => {
//         formErrors["streetOne"] = "";
//         formErrors["city"] = "";
//         formErrors["state"] = "";
//         formErrors["country"] = "";
//         formErrors["postcode"] = "";
//         this.setState({
//           clientData: clientData,
//           locGoogleCodes: locGoogleCodes,
//           formErrors,
//         });
//       })
//       .catch((error) => console.error("Error", error));
//   };

googleLocSelect = (address,id) =>{ 
    let {formErrors} = this.state; 
    let clientData = this.state.clientData;
    let locGoogleCodes  = this.state.locGoogleCodes; 

    geocodeByAddress(address)
    .then(results => {    
        if (id==="googleLocation") {       
        clientData.companyInfo.streetOne = ''; 
        clientData.companyInfo.streetTwo = ''; 
        clientData.companyInfo.city = ''; 
        clientData.companyInfo.state = ''; 
        clientData.companyInfo.country = ''; 
        clientData.companyInfo.postcode = '';   
        clientData.companyInfo.location = results[0].formatted_address; 
        let tmpArr = [];
        tmpArr = address.split(','); 
        clientData.companyInfo.venue = tmpArr[0]; 

        locGoogleCodes.streetOne = ''; 
        locGoogleCodes.streetTwo = ''; 
        locGoogleCodes.city = ''; 
        locGoogleCodes.state = ''; 
        locGoogleCodes.country = ''; 
        locGoogleCodes.postcode = ''; 

        let allAddress = results[0].address_components;
        let addrTypes = []; 
        let foundVar = 0; 
        let tmpVal = ''; 
        allAddress.forEach(element => {
            addrTypes = element.types;
            foundVar = 0; 
            addrTypes.forEach(item => {
                tmpVal = element.long_name.trim().length ? element.long_name.trim() : ((element.short_name.trim().length) ? element.short_name.trim() : '') ;
                if(foundVar===0 && tmpVal!=='') { 
                    if(gLoc.GOOGLE_LOCATION_STREET.includes(item)) {
                        foundVar = 1; 
                        if(clientData.companyInfo['streetOne'].trim()==='') clientData.companyInfo['streetOne'] = tmpVal; 
                        else clientData.companyInfo['streetOne'] += ', '+tmpVal;  

                        if(locGoogleCodes['streetOne'].trim()==='') locGoogleCodes['streetOne'] = item; 
                        else locGoogleCodes['streetOne'] += ', '+item; 
                    } 
                    else if(gLoc.GOOGLE_LOCATION_STREET2.includes(item)) {
                        foundVar = 1; 
                        if(clientData.companyInfo['streetTwo'].trim()==='') clientData.companyInfo['streetTwo'] = tmpVal; 
                        else clientData.companyInfo['streetTwo'] += ', '+tmpVal; 
                        if(locGoogleCodes['streetTwo'].trim()==='') locGoogleCodes['streetTwo'] = item; 
                        else locGoogleCodes['streetTwo'] += ', '+item; 
                    } 
                    else if(gLoc.GOOGLE_LOCATION_CITY.includes(item)) {
                        foundVar = 1; 
                        if(clientData.companyInfo['city'].trim()==='') clientData.companyInfo['city'] = tmpVal; 
                        else clientData.companyInfo['city'] += ', '+tmpVal; 
                        if(locGoogleCodes['city'].trim()==='') locGoogleCodes['city'] = item; 
                        else locGoogleCodes['city'] += ', '+item; 
                    } 
                    else if(gLoc.GOOGLE_LOCATION_STATE.includes(item)) {
                        foundVar = 1; 
                        if(clientData.companyInfo['state'].trim()==='') clientData.companyInfo['state'] = tmpVal; 
                        else clientData.companyInfo['state'] += ', '+tmpVal; 
                        if(locGoogleCodes['state'].trim()==='') locGoogleCodes['state'] = item; 
                        else locGoogleCodes['state'] += ', '+item; 
                    } 
                    else if(gLoc.GOOGLE_LOCATION_COUNTRY.includes(item)) {
                        foundVar = 1; 
                        if(clientData.companyInfo['country'].trim()==='') clientData.companyInfo['country'] = tmpVal; 
                        else clientData.companyInfo['country'] += ', '+tmpVal; 
                        if(locGoogleCodes['country'].trim()==='') locGoogleCodes['country'] = item; 
                        else locGoogleCodes['country'] += ', '+item; 
                    }
                    else if(gLoc.GOOGLE_LOCATION_POSTCODE.includes(item)) {
                        foundVar = 1; 
                        if(clientData.companyInfo['postcode'].trim()==='') clientData.companyInfo['postcode'] = tmpVal; 
                        else clientData.companyInfo['postcode'] += ', '+tmpVal; 
                        if(locGoogleCodes['postcode'].trim()==='') locGoogleCodes['postcode'] = item; 
                        else locGoogleCodes['postcode'] += ', '+item; 
                    }
                }
            })
        })

        getLatLng(results[0]).then(latLng=>{
            clientData.companyInfo['googleLocation'] = latLng.lat+','+latLng.lng;
        })
    }else
        {       
            clientData.companyInfo.streetOneBilling = ''; 
            clientData.companyInfo.streetTwoBilling = ''; 
            clientData.companyInfo.cityBilling = ''; 
            clientData.companyInfo.stateBilling = ''; 
            clientData.companyInfo.countryBilling = ''; 
            clientData.companyInfo.postcodeBilling = '';   
            clientData.companyInfo.locationBilling = results[0].formatted_address; 
            let tmpArr = [];
            tmpArr = address.split(','); 
            clientData.companyInfo.venueBilling = tmpArr[0]; 

            let allAddress = results[0].address_components;
            let addrTypes = []; 
            let foundVar = 0; 
            let tmpVal = ''; 
            allAddress.forEach(element => {
                addrTypes = element.types;
                foundVar = 0; 
                addrTypes.forEach(item => {
                    tmpVal = element.long_name.trim().length ? element.long_name.trim() : ((element.short_name.trim().length) ? element.short_name.trim() : '') ;
                    if(foundVar===0 && tmpVal!=='') { 
                        if(gLoc.GOOGLE_LOCATION_STREET.includes(item)) {
                            foundVar = 1; 
                            if(clientData.companyInfo['streetOneBilling'].trim()==='') clientData.companyInfo['streetOneBilling'] = tmpVal; 
                            else clientData.companyInfo['streetOneBilling'] += ', '+tmpVal;  
                        } 
                        else if(gLoc.GOOGLE_LOCATION_STREET2.includes(item)) {
                            foundVar = 1; 
                            if(clientData.companyInfo['streetTwoBilling'].trim()==='') clientData.companyInfo['streetTwoBilling'] = tmpVal; 
                            else clientData.companyInfo['streetTwoBilling'] += ', '+tmpVal;
                        } 
                        else if(gLoc.GOOGLE_LOCATION_CITY.includes(item)) {
                            foundVar = 1; 
                            if(clientData.companyInfo['cityBilling'].trim()==='') clientData.companyInfo['cityBilling'] = tmpVal; 
                            else clientData.companyInfo['cityBilling'] += ', '+tmpVal; 
                        } 
                        else if(gLoc.GOOGLE_LOCATION_STATE.includes(item)) {
                            foundVar = 1; 
                            if(clientData.companyInfo['stateBilling'].trim()==='') clientData.companyInfo['stateBilling'] = tmpVal; 
                            else clientData.companyInfo['stateBilling'] += ', '+tmpVal; 
                        } 
                        else if(gLoc.GOOGLE_LOCATION_COUNTRY.includes(item)) {
                            foundVar = 1; 
                            if(clientData.companyInfo['countryBilling'].trim()==='') clientData.companyInfo['countryBilling'] = tmpVal; 
                            else clientData.companyInfo['countryBilling'] += ', '+tmpVal; 
                        }
                        else if(gLoc.GOOGLE_LOCATION_POSTCODE.includes(item)) {
                            foundVar = 1; 
                            if(clientData.companyInfo['postcodeBilling'].trim()==='') clientData.companyInfo['postcodeBilling'] = tmpVal; 
                            else clientData.companyInfo['postcodeBilling'] += ', '+tmpVal;
                        }
                    }
                })
            })
    }
    }).then( () => {
        if(id==="googleLocation"){
        formErrors['streetOne'] = '';
        formErrors['city'] = '';
        formErrors['state'] = '';
        formErrors['country'] = '';
        formErrors['postcode'] = '';
        formErrors['location'] = '';
        }else{
            formErrors['streetOneBilling'] = '';
            formErrors['cityBilling'] = '';
            formErrors['stateBilling'] = '';
            formErrors['countryBilling'] = '';
            formErrors['postcodeBilling'] = '';
            formErrors['locationBilling'] = '';
        }
        this.setState({clientData:clientData,locGoogleCodes:locGoogleCodes,formErrors});
    })
    .catch(error => console.error('Error', error));
}

  onGetGoogleLoc = (e, id) => {
    const { name, checked } = e.target;
    const { clientData } = this.state;
    const isBilling = id === "noLocationFoundBilling";
  
    const fields = [
      "locationId",
      "venue",
      "googleLocation",
      "streetOne",
      "streetTwo",
      "city",
      "state",
      "country",
      "postcode",
    ];
  
    // Prefix fields with "Billing" if it's for billing
    fields.forEach((field) => {
      const key = isBilling ? `${field}Billing` : field;
      clientData.companyInfo[key] = "";
    });
  
    // Set "noLocationFound" field
    const noLocationKey = isBilling ? "noLocationFoundBilling" : "noLocationFound";
    clientData.companyInfo[noLocationKey] = checked;
  
    // Update the specific checkbox value
    clientData.companyInfo[name] = checked;
  
    this.setState({ clientData });
  };
  

  componentDidUpdate(prevProps) {
    const {
      client,
      status,
      activity,
      errorData,
      dynFieldsStatus,
      dynFieldsActivity,
      timezonesListStatus,
      timezonesListActivity,
      clientProfileTabActive,
      validateResponse,
      validateStatus,
      validateActivity,
      validateErrorData,
    } = this.props;

    if (
      validateActivity &&
      (validateStatus !== prevProps.validateStatus ||
        validateActivity !== prevProps.validateActivity)
    ) {
      var arrTemp = validateActivity.split("~~");
      if (
        arrTemp[0] === types.VALIDATE_CLIENT_ADD_SUCCESS ||
        arrTemp[0] === types.VALIDATE_CLIENT_DETAILS_SUCCESS
      ) {
        if (validateStatus === 200) {
          this.setState({ validationMsgArr: [] });
        } else if (validateStatus !== 200) {
          if (
            validateResponse &&
            validateResponse.hasOwnProperty("mandatories") &&
            validateResponse.mandatories &&
            Array.isArray(validateResponse.mandatories)
          ) {
            this.setState({ validationMsgArr: validateResponse.mandatories });
          } else {
            this.setState({ validationMsgArr: [] });
            // this.setState({validationMsgArr:['common_error']});
            console.log("validateResponse not have mandatories array/object");
            console.log(validateResponse);
          }
        } // validateErrorData
      }
    }

    if (activity !== prevProps.activity) {
      this.setStateUpdate(client, activity, status, errorData);
      this.props.clearAction();
    }

    // CHECKING DYNAMIC FIELDS DATA LISTING
    if (
      dynFieldsActivity &&
      (dynFieldsStatus !== prevProps.dynFieldsStatus ||
        dynFieldsActivity !== prevProps.dynFieldsActivity)
    ) {
      var arrResp = dynFieldsActivity.split("~~");
      var actString = arrResp[0];

      // types.DYNAMIC_FIELDS_LIST_SUCCESS, types.DYNAMIC_FIELDS_LIST_ERROR
      if (actString === types.DYNAMIC_FIELDS_LIST_SUCCESS) {
        if (this.props.hasOwnProperty("dynFieldsAllItems")) {
          if (this.props.dynFieldsAllItems.length === 0) {
            this.setState({ dynFieldsAllItems: [] });
          } else {
            let tmpObj = {};
            let fieldsObj = {};
            let allPagesObj = [];
            this.props.dynFieldsAllItems.forEach((rObj) => {
              if (!Array.isArray(rObj.field_details)) rObj.field_details = []; // IF OBJECT {} RETURNED, CONVERT TO ARRAY
              if (rObj.show_tab && rObj.field_details.length > 0) {
                fieldsObj = rObj.field_details;
                let iconName = "";
                if (
                  !rObj.icon_name ||
                  rObj.icon_name === null ||
                  rObj.icon_name.trim().length === 0
                ) {
                  let filterObj = { pageName: "", iconName: "" };
                  filterObj = DYNAMIC_PAGE_ICONS.filter(
                    (pageDet) =>
                      pageDet.pageName.trim().toLowerCase() ===
                      rObj.name.trim().toLowerCase()
                  ); // DEFINED IN staticConfigs.js
                  if (filterObj.length) iconName = filterObj[0].iconName;
                } else {
                  iconName = rObj.icon_name;
                }

                tmpObj = {
                  id: rObj.id,
                  name: rObj.name,
                  field_details: fieldsObj,
                  show_tab: rObj.show_tab,
                  icon_name: iconName,
                  user_type: rObj.user_type,
                };

                allPagesObj.push(tmpObj);
              }
            });
            this.setState({ dynFieldsAllItems: allPagesObj }, () => {});
          }
        } else {
          this.setState({ dynFieldsAllItems: [] });
        }
      } else if (actString === types.DYNAMIC_FIELDS_LIST_ERROR) {
        this.setState({
          toastSuccess: false,
          toastFlag: true,
          toastMessage: MSG_ERROR,
        });
        setTimeout(() => {
          this.onCloseToast();
        }, 3000);
      } else if (actString === types.DYNAMIC_FIELDS_DATA_SAVE_SUCCESS) {
        this.callValidate();
        this.setState({
          toastSuccess: true,
          toastFlag: true,
          toastMessage: MSG_DYNAMIC_FIELD_DATA_SAVE_SUCCESS,
        });
        setTimeout(() => {
          this.onCloseToast();
        }, 3000);
      } else if (actString === types.DYNAMIC_FIELDS_DATA_SAVE_ERROR) {
        this.setState({
          toastSuccess: false,
          toastFlag: true,
          toastMessage: MSG_DYNAMIC_FIELD_DATA_SAVE_ERROR,
        });
        setTimeout(() => {
          this.onCloseToast();
        }, 4000);
      }
    }

    if (
      timezonesListStatus !== prevProps.timezonesListStatus ||
      timezonesListActivity !== prevProps.timezonesListActivity
    ) {
      let arrResp = timezonesListActivity
        ? timezonesListActivity.split("~~")
        : [];
      let actString = arrResp[0];
      if (actString === types.TIMEZONES_LIST_SUCCESS) {
        if (timezonesListStatus === 200) {
          let tz = this.props.timeZonesAllItems;
          let newTZ = tz.filter(
            (item) =>
              item.region.trim().toLowerCase() ===
              DEFAULT_TIME_ZONE.trim().toLowerCase()
          );
          let defTZId = 0;
          if (newTZ.length) defTZId = newTZ[0].id;
          let clientData = this.state.clientData;
          if (!clientData.companyInfo.timeZone)
            clientData.companyInfo.timeZone = defTZId;
          this.setState({
            clientData: clientData,
            defaultTimeZoneId: defTZId,
            timeZonesList: this.props.timeZonesAllItems,
          });
        } else {
          // timezonesListErrorData
          this.setState({
            toastSuccess: false,
            toastFlag: true,
            toastMessage: MSG_TIMEZONE_DATA_ERROR,
          });
          setTimeout(() => {
            this.onCloseToast();
          }, 5000);
        }
      } else if (actString === types.TIMEZONES_LIST_ERROR) {
        // timezonesListErrorData
        this.setState({
          toastSuccess: false,
          toastFlag: true,
          toastMessage: MSG_TIMEZONE_DATA_ERROR,
        });
        setTimeout(() => {
          this.onCloseToast();
        }, 5000);
      }
    }
  }

  componentDidMount() {
    const { location } = this.props;
    let userGroupData = userGroupUrlCheck(location);
    let userGroup = "";
    if (userGroupData !== undefined) {
      userGroup = userGroupData.user_group;
    }

    if (
      userGroup === LOGIN_AFFILIATE_GROUP &&
      this.state.clientId !== undefined
    ) {
      this.props.clientListSetSliderClientId(this.state.clientId);
      this.props.history.push(ROUTE_AFFILIATE_CLIENTS);
      this.props.clientCategoryList();
    }

    if (this.state.timeZonesList.length === 0) {
      this.props.timeZonesListAction();
    }

    if (this.state.clientId !== undefined) {
      const clientId = this.state.clientId;
      this.props.clientEditAction(clientId);
      this.props.validateClientDetailsAction(clientId); // TO VALIDATE MANDATORY DATA ADDED WHITE EDIT CLIENT DETAILS
    } else {
      this.props.validateClientAddAction(); // TO VALIDATE MANDATORY DATA ADDED BEFORE CREATING CLIENT
    }

    if (userGroup === LOGIN_AFFILIATE_GROUP) {
      if (this.state.clientId !== undefined)
        document.title = LBL_APP_NAME + " - " + LBL_EDIT_CLIENT;
      else document.title = LBL_APP_NAME + " - " + LBL_ADD_CLIENT;

      document.body.classList.add("body-affiliate");
    } else if (userGroup === LOGIN_CLIENT_GROUP) {
      document.title = LBL_APP_NAME + " - " + LBL_COMPANY_PROFILE;
      document.body.classList.add("body-client");
    } else {
      document.body.classList.add("body-super");
    }

    // let grpProfileId = userGroupData.profile_id;
    // let listDynData = {groupId: LOGIN_CLIENT_GROUP, reqFrom:userGroup, profileId:grpProfileId};
    // this.setState({listDynData:listDynData}, () => {
    //     this.props.dynamicFieldsListAction(listDynData);
    // });
  }

  render() {
    const { status, locationsList, prmryUsers } = this.props; // sectors,subSectors,
    const { toastMessage, toastFlag, toastSuccess, clientId } = this.state;

    let userGroupData = userGroupUrlCheck(this.props.location);
    let userGroup = "";
    if (userGroupData !== undefined) {
      userGroup = userGroupData.user_group;
    }

    if (status === 401 || status === 403) {
      if (userGroup === LOGIN_AFFILIATE_GROUP) {
        return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
      } else {
        return <Redirect to={ROUTE_REFRESH} />;
      }
    }

    let companyName = "";
    if (this.state.clientData.companyInfo.companyName)
      companyName = this.state.clientData.companyInfo.companyName;
    //let primeEmail = this.state.clientData.primaryContact.emailAddress;

    let validationMsgStr = "";
    if (this.state.validationMsgArr.length) {
      if (!clientId) {
        // CLIENT ADD VALIDATION
        console.log("this.state.validationMsgArr");
        console.log(this.state.validationMsgArr);
        this.state.validationMsgArr.forEach((item) => {
          if (validationMsgClientAdd[item]) {
            validationMsgStr += validationMsgClientAdd[item]
              ? validationMsgClientAdd[item] + ""
              : "";
          } else {
            console.log(item + " not listed in validationMsgClientAdd");
          }
        });
        // EXCEPTION HANDLING
        // if(validationMsgStr==='') validationMsgStr = validationMsgClientAdd['common_error'];
      } else {
        this.state.validationMsgArr.forEach((item) => {
          if (item.documents) {
            validationMsgStr +=
              validationMsgClientDetails["documents_START"] +
              item.documents.join(", ") +
              validationMsgClientDetails["documents_END"];
          } else {
            if (validationMsgClientDetails[item]) {
              validationMsgStr += validationMsgClientDetails[item]
                ? validationMsgClientDetails[item] + ""
                : "";
            } else {
              console.log(item + " not listed in validationMsgClientDetails");
            }
          }
        });

        // EXCEPTION HANDLING
        // if(validationMsgStr==='') validationMsgStr = validationMsgClientDetails['common_error'];
        // else validationMsgStr = validationMsgClientDetails['common_header']+validationMsgStr;
      }
    }

    let pcEmail = this.state.primaryContactEmailAddress
      ? this.state.primaryContactEmailAddress
      : "";
    let default_event_key = "company-info-tab";
    if (this.props.fromExpiryCertificatesWindow) {
      default_event_key = "documents-tab";
      this.props.fromExpiryCertificates(false);
    }

    return (
      <React.Fragment>
        <Toast
          toastDescription={toastMessage}
          toastFlag={toastFlag}
          toastSuccess={toastSuccess}
          closeToast={this.onCloseToast}
        />

        <Tab.Container id="profile-tab" defaultActiveKey={default_event_key}>
          {validationMsgStr.length > 0 && (
            <div className="text-validation">
              <small>{ReactHtmlParser(validationMsgStr)}</small>
            </div>
          )}

          <div className="col-md-4 col-lg-3 col-xl-2 col-12">
            <Nav variant="pills" className="nav flex-column nav-pills box">
              <Nav.Link
                onClick={(e) => this.onTabChange(e, TAB1)}
                eventKey="company-info-tab"
              >
                <i className="la la-cube"></i>
                <small>Basic Info</small>
              </Nav.Link>

              {Number(clientId) > 0 && (
                <Nav.Link
                  className={clientId === undefined ? "disabled" : ""}
                  onClick={(e) => this.onTabChange(e, TAB2)}
                  eventKey="company-primary-contact-tab"
                >
                  <i className="las la-user-astronaut"></i>{" "}
                  <small>Primary Contact</small>
                </Nav.Link>
              )}

              {Number(clientId) > 0 && pcEmail && pcEmail.length > 1 && (
                <Nav.Link
                  className={clientId === undefined ? "disabled" : ""}
                  onClick={(e) => this.onTabChange(e, TAB3)}
                  eventKey="contact-details-tab"
                >
                  <i className="las la-map-marker-alt"></i>{" "}
                  <small>Contact Details</small>
                </Nav.Link>
              )}

              {userGroup !== LOGIN_CLIENT_GROUP &&
                Number(clientId) > 0 &&
                pcEmail &&
                pcEmail.length > 1 && (
                  <Nav.Link
                    className={clientId === undefined ? "disabled" : ""}
                    onClick={(e) => this.onTabChange(e, TAB4)}
                    eventKey="rate-card-tab"
                  >
                    <i className="las la-money-check-alt"></i>{" "}
                    <small>{LBL_RATE_CARD}</small>
                  </Nav.Link>
                )}
              {/*                         
                            {(Number(clientId) > 0 || userGroup===LOGIN_CLIENT_GROUP) && Number(clientId) > 0 && <Nav.Link className={clientId===undefined?'disabled':''} onClick={(e) => this.onTabChange(e, TAB5)} eventKey="events-tab"><i className="las la-calendar-day"></i> <small>Events</small></Nav.Link> } */}

              {Number(clientId) > 0 && pcEmail && pcEmail.length > 1 && (
                <Nav.Link
                  className={clientId === undefined ? "disabled" : ""}
                  onClick={(e) => this.onTabChange(e, TAB6)}
                  eventKey="documents-tab"
                >
                  <i className="las la-file-alt"></i> <small>Documents</small>
                </Nav.Link>
              )}

              {Number(clientId) > 0 &&
                pcEmail &&
                pcEmail.length > 1 &&
                this.state.hasOwnProperty("dynFieldsAllItems") &&
                this.state.dynFieldsAllItems.map((item, index) => {
                  return (
                    <Nav.Link
                      className={clientId === undefined ? " disabled" : ""}
                      onClick={(e) =>
                        this.state.activePageId !== item.id
                          ? this.changePage(e, item.id)
                          : ""
                      }
                      eventKey={"company-Dynamic-tab_" + index}
                      key={index}
                    >
                      <i className={item.icon_name}></i>{" "}
                      <small>{item.name}</small>
                    </Nav.Link>
                  );
                })}
            </Nav>
          </div>
          <div className="col-md-8 col-lg-9 col-xl-10 col-12 pl-0">
            <Tab.Content>
              <Tab.Pane eventKey="company-info-tab">
                {/* sectors={sectors} subSectors={subSectors} */}
                <CompanyInfo
                  showNameInHeader={companyName}
                  locations={locationsList}
                  onsearchLocation={this.onSearchLocation}
                  onPhoneInputChange={this.onPhoneInputChange}
                  onSelectLocation={(e, id) => this.onSelectLocation(e, id)}
                  saveFormData={(e) => this.saveFormData(e, TAB1)}
                  onHandleChange={(e) => this.onHandleChange(e, TAB1)}
                  deactivateUser={(e) => this.deactivateUser()}
                  activateUser={(e) => this.activateUser()}
                  {...this.state}
                  onGetGoogleLoc={(e,id) => this.onGetGoogleLoc(e,id)}
                  googleLocSelect={(e,id) => this.googleLocSelect(e,id)} 
                  is_active={this.state.is_active}
                  client_affiliate_status={this.state.client_affiliate_status}
                />
              </Tab.Pane>

              <Tab.Pane eventKey="company-primary-contact-tab">
                <PrimaryContact
                  showNameInHeader={companyName}
                  users={prmryUsers}
                  saveFormData={(e) => this.saveFormData(e, TAB2)}
                  onContactInputChange={this.onContactInputChange}
                  onHandleChange={(e) => this.onHandleChange(e, TAB2)}
                  onSelectPrmyUser={(e) => this.onSelectPrmyUser(e)}
                  resendEmail={(e) => this.resendEmail(e)}
                  {...this.state}
                />
              </Tab.Pane>

              <Tab.Pane eventKey="contact-details-tab">
                {clientId !== undefined && (
                  <ContactDetails
                    showNameInHeader={companyName}
                    setToasterState={this.setToasterState}
                    resendEmail={(e) => this.resendEmail(e)}
                    {...this.state}
                  />
                )}
              </Tab.Pane>

              {userGroup !== LOGIN_CLIENT_GROUP && (
                <Tab.Pane eventKey="rate-card-tab">
                  <RateCard
                    showNameInHeader={companyName}
                    clientId={this.state.clientId}
                    {...this.state}
                  />
                </Tab.Pane>
              )}

              {/* <Tab.Pane eventKey="events-tab">
                               <Events showNameInHeader={companyName}  saveFormData={(e) => this.saveFormData(e, TAB5)} onHandleChange={(e) => this.onHandleChange(e, TAB5)} {...this.state} 
                               />
                            </Tab.Pane>                                                  */}
              <Tab.Pane eventKey="documents-tab">
                {
                  clientId !== undefined && (
                    <Documents
                      {...this.state}
                      showNameInHeader={companyName}
                      callparentValidate="yes"
                      callValidate={this.callValidate}
                      document="1"
                      client_id={clientId}
                    />
                  )
                  // VARIABLES document AND client_id ARE PASSED ON THE REQUEST OF SERVER TEAM ON 24Nov2020
                }
              </Tab.Pane>

              {this.state.hasOwnProperty("dynFieldsAllItems") &&
                this.state.dynFieldsAllItems.map((item, index) => {
                  return (
                    <Tab.Pane
                      eventKey={"company-Dynamic-tab_" + index}
                      key={index}
                    >
                      <DynamicFieldsDetails
                        showNameInHeader={companyName}
                        dynamicFieldsDataSaveAction={(e) =>
                          this.props.dynamicFieldsDataSaveAction(e)
                        }
                        {...this.state}
                        headerText={item.name}
                        dynFieldsActiveItem={item}
                        dynamicFieldsFor={LOGIN_CLIENT_GROUP}
                      />
                    </Tab.Pane>
                  );
                })}
            </Tab.Content>
          </div>
        </Tab.Container>
        <ModalWindow
          ref={this.logoModalCropper}
          type="imageCropper"
          saveFormData={(e) => this.cropImage(e, "clientLogo")}
        >
          <Cropper
            image={this.state.logoImgUrl}
            crop={this.state.crop}
            zoom={this.state.zoom}
            aspect={this.state.aspect}
            onCropChange={this.onCropChange}
            onCropComplete={this.onCropComplete}
            onZoomChange={this.onZoomChange}
          />
        </ModalWindow>
        <ModalWindow
          ref={this.signModalCropper}
          type="imageCropper"
          saveFormData={(e) => this.cropImage(e, "clientSign")}
        >
          <Cropper
            image={this.state.signImgUrl}
            crop={this.state.crop}
            zoom={this.state.zoom}
            aspect={this.state.aspect}
            onCropChange={this.onCropChange}
            onCropComplete={this.onCropComplete}
            onZoomChange={this.onZoomChange}
          />
        </ModalWindow>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    client: state.clients.item,
    clientCategoryData: state.clients.clientCategoryList,
    status: state.clients.status,
    activity: state.clients.activity,
    locationsList: state.clients.locations,
    prmryUsers: state.clients.prmryUsers,
    errorData: state.clients.errorData,
    clientUpdatedData: state.clients.clientUpdatedData,

    dynFieldsStatus: state.dynamicFields.dynFieldsStatus,
    dynFieldsActivity: state.dynamicFields.dynFieldsActivity,
    dynFieldsAllItems: state.dynamicFields.dynFieldAllItems,
    newClientId: state.clients.newClientId,
    timeZonesAllItems: state.timeZones.timezonesList,
    timezonesListStatus: state.timeZones.timezonesListStatus,
    timezonesListActivity: state.timeZones.timezonesListActivity,
    timezonesListErrorData: state.timeZones.timezonesListErrorData,
    clientProfileTabActive: state.certificates.clientProfileTabActive,

    validateResponse: state.validate.validateResponse,
    validateStatus: state.validate.validateStatus,
    validateActivity: state.validate.validateActivity,
    validateErrorData: state.validate.validateErrorData,
    fromExpiryCertificatesWindow: state.commons.fromExpiryCertificatesWindow,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      masterLocationListAction: (data) => masterLocationListAction(data),
      primaryUsersListAction: primaryUsersListAction,
      clientEditAction: (id) => clientEditAction(id),
      clientCompanyInfoAddAction: (data) => clientCompanyInfoAddAction(data),
      clientCompanyInfoUpdateAction: (data) =>
        clientCompanyInfoUpdateAction(data),
      clientPrmryCntAddAction: (data) => clientPrmryCntAddAction(data),
      clientPrmryCntUpdateAction: (data) => clientPrmryCntUpdateAction(data),
      clientActiveDeactiveAction: (id) => clientActiveDeactiveAction(id),
      clearAction: clearAction,
      resendEmailAction: resendEmailAction,
      dynamicFieldsListAction: dynamicFieldsListAction,
      dynamicFieldsDataSaveAction: dynamicFieldsDataSaveAction,
      clientContactListAction: clientContactListAction,
      timeZonesListAction: timeZonesListAction,
      clientProfileDeactiveTabAction: clientProfileDeactiveTabAction,
      validateClientAddAction: validateClientAddAction,
      validateClientDetailsAction: validateClientDetailsAction,
      fromExpiryCertificates: fromExpiryCertificates,
      clientListSetSliderClientId: clientListSetSliderClientId,
      clientCategoryList: clientCategoryList,
    },
    dispatch
  );
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientProfileComponent);
